import { images } from "../constants";

const testimonials = [  
    {
        id: 1,
        image: images.testimonial1,
        name: 'Emily Parker',
        title: 'Food Enthusiast',
        content: 'Dining at this restaurant was an unforgettable experience. The flavors were exquisite, and the presentation of each dish was a work of art. The ambiance was perfect for a special evening, and the service was impeccable.'
    },
    {
        id: 2,
        image: images.testimonial2,
        name: 'John Smith',
        title: 'Gourmet Reviewer',
        content: 'The restaurant offers a delightful array of dishes that cater to every palate. The attention to detail in both the food and the service was evident. It’s a place I’ll definitely recommend for anyone looking to enjoy a top-notch dining experience.'
    },
    {
        id: 3,
        image: images.testimonial3,
        name: 'Sarah Johnson',
        title: 'Event Planner',
        content: 'I recently hosted an event here, and the catering service exceeded all expectations. The food was exceptional, and the staff went above and beyond to ensure everything was perfect. Highly recommend for any special occasion.'
    },
    {
        id: 4,
        image: images.testimonial4,
        name: 'Michael Brown',
        title: 'Regular Diner',
        content: 'Every visit to this restaurant is a treat. The menu is diverse, and the quality of the food is consistently outstanding. The atmosphere is warm and inviting, making it a perfect spot for both casual meals and special celebrations.'
    },
];

export default testimonials;